import {ArrayElement} from 'shared/web';

import {DefinitionResponseBody, EnumColumnResponseBody} from '../types/Api';

export const isEnumColumnResponseBody = (
  data: ArrayElement<DefinitionResponseBody['columns']>
): data is EnumColumnResponseBody => 'enumType' in data;
